import axios from 'axios';
import Eos from 'eosjs';

// Store modules
import auth from './auth';
import * as AmazonCognitoIdentity from 'amazon-cognito-identity-js';
const AWS = require('aws-sdk')
var CognitoUserPool = AmazonCognitoIdentity.CognitoUserPool;

const BASE_URL = 'https://api.smartpress.co'
// const BASE_URL = 'http://localhost:3000'

// initial state
const state = {
 
  sessionId: {'ss':'ssss'},
  userBilling: {}
}


const getters = { 
}

const mutations = {
  setSessionId (state) {
    state.sessionId = state
  },
  setBillingInfo (state) {
    state.userBilling = state
  }
}

const actions = {
  stripeSessionA(context, params) {
    console.log(BASE_URL + '/b/createSessionId')
    console.log(params)

    return new Promise(function(resolve, reject) {
     auth.state.getSession.then((token) => {
        console.log(token.accessToken.payload)
        var config = {
            headers: {'Authorization': "bearer " + token.accessToken.jwtToken, 
                  'accesstoken': token.accessToken.jwtToken}
        };
        
          axios
            .post(BASE_URL + '/b/createSessionId', {}, config)
            .then((trx) => {
              (context.commit('payments/setSessionId', trx, { root: true }))

            resolve(trx)
          })
        })
      })
    },
    stripePaySuccess(context, params) {

    return new Promise(function(resolve, reject) {
     auth.state.getSession.then((token) => {
      console.log(token.accessToken.payload)
      var config = {
          headers: {'Authorization': "bearer " + token.accessToken.jwtToken, 
                'accesstoken': token.accessToken.jwtToken}
      };
      
        axios
          .post(BASE_URL + '/b/paymentSuccess', {
            session_id: params.session_id,
          }, config)
        })
      })
    },
    getUserBilling(context, params) {

    return new Promise(function(resolve, reject) {
     auth.state.getSession.then((token) => {
      console.log(token.accessToken.payload)
      var config = {
          headers: {'Authorization': "bearer " + token.accessToken.jwtToken, 
                'accesstoken': token.accessToken.jwtToken}
      };
      
        axios
          .post(BASE_URL + '/b/userBilling', {}, config)
          .then((trx) => {
              (context.commit('payments/setBillingInfo', trx, { root: true }))

            resolve(trx)
        })
      })
    })
  }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}